import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import calendarHandler from 'node-ical';
import Moment from 'moment';
import { updateFormData, setListing, updateListing, reinitializeCalendars, updateCalendars, getCalendar } from '../actions';
import { populateListingFromFormData } from '../helpers';
import { AvailabilitySchema } from '../validation';
import { getAdminModifiers, dateRange } from '../../../../calendarHelper';
import CalendarComponent from '../../../global/calendar-component';
import FormikRadioButton from '../../../ui/FormikRadioButton';
import ToolTip from '../../../ui/ToolTip';
import { saveListing } from './listingFormAmenities';

const mapStateToProps = state => ({
  formData: state.Listing.formData,
  calendars: state.Listing.calendars,
  bookings: state.Listing.listingBookings,
  global: state.Global,
  listing: state.Listing
});

class ListingFormManageAvailability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDaysParent: [],
      isSubmitting: false,
      singleDay: true,
      from: undefined,
      to: undefined
    }

    const workflow = props.workflow ? props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/preview`;
    this.prevPage = `/${this.props.parent}/listing/${workflow}/calendars`;
  }

  componentDidMount() {
    this.props.dispatch(reinitializeCalendars());
    this.props.formData.calendars.forEach((c) => {
      getCalendar(c, this.handleFile);
    });
  }

  dateHandler = (day, selected) => {
    if (this.state.singleDay === true) {
      let selectedDaysCopy = this.state.selectedDaysParent.slice();

      if (selected) {
        const selectedIndex = selectedDaysCopy.findIndex(selectedDay =>
          DateUtils.isSameDay(selectedDay, day)
        );
        selectedDaysCopy.splice(selectedIndex, 1);
      } else {
        selectedDaysCopy.push(day);
      }

      this.setState({ selectedDaysParent: selectedDaysCopy });
    } else {
      let range = DateUtils.addDayToRange(day, this.state);
      this.setState({ from: range.from, to: range.to });

      let rangeCopy = Object.assign({}, range);
      if (rangeCopy.to !== undefined) {
        let days = dateRange(rangeCopy.from, rangeCopy.to);
        this.setState({ selectedDaysParent: days });
      }
    }
  }

  handleFile = (response) => {
    let { dispatch } = this.props;
    let responseLower = response.toLowerCase();
    let type = "other";
    if (responseLower.includes("airbnb")) {
      type = "airbnb";
    } else if (responseLower.includes("homeaway")) {
      type = "vrbo";
    }
    calendarHandler.parseICS(response, function (err, data) {
      dispatch(updateCalendars(data, type));
    });
  }

  exit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true });
    let { dispatch, history } = this.props;
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      setSubmitting(false);
      dispatch(setListing(updatedData));
      dispatch(updateListing());
      (history.location.search === '?return=dash') ? history.push(`/${this.props.parent}`) : history.push(`/${this.props.parent}/manage-listings?view=ma`);
    }, 1000)
  }

  saveFormListing = (values, pathAfterSave) => {
    this.setState({ isSubmitting: true });
    saveListing(values, pathAfterSave, this.props);
  }

  onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    this.saveFormListing(values, this.nextPage);
  }

  submitAndBack = (values) => {
    this.saveFormListing(values, this.prevPage);
  }

  submitAndExit = (values) => {
    this.saveFormListing(values, `/${this.props.parent}/manage-listings`);
  }

  update = (values, setSubmitting, errors) => {
    setSubmitting(false);
    this.state.selectedDaysParent.forEach(x => {
      values.pricing.overrides = values.pricing.overrides.filter(y => !Moment(y.date).isSame(x, 'day'));
    })
    this.state.selectedDaysParent.forEach(x => {
      if (values.adjustment !== values.pricing.baseFee) {
        values.pricing.overrides.push({
          availability: values.availability,
          price: values.adjustment ? values.adjustment : values.pricing.baseFee,
          date: x
        });
      }
    });
    values.availability = '';
    values.adjustment = '';
    this.props.dispatch(updateFormData(values));
    this.setState({ selectedDaysParent: [] });
  }

  renderCalendarMessage = () => {
    let { formData, calendars } = this.props;
    if (formData.calendars.length > 0) {
      return (formData.calendars.length !== calendars.length ?
        <div className="loading-calendar-data">Loading calendar data...</div> :
        <span className="calendar-sync"><i className="fas fa-check-circle"></i>Calendars successfully synced.</span>
      )
    }
    return null
  }

  render() {
    let { formData, calendars, bookings } = this.props;
    let instantToolTip = "Allow renters to book your property instantly for available dates.";
    let requestToolTip = "Review the renter's profile and request before accepting or denying a stay request";
    let calendarBookings = bookings ? bookings.filter(x =>
      x.bookingRequestStatus === 'Accepted'
      && x.bookingPaymentStatus !== 'Cancelled'
      && x.bookingPaymentStatus !== 'Pending') : [];
    const submitButtonText = this.props.exit ? 'Save' : 'Next';
    return (
      <Formik
        onSubmit={this.props.exit ? this.exit : this.onSubmit}
        initialValues={formData}
        validationSchema={AvailabilitySchema}>
        {({ values, setSubmitting, errors, touched, isSubmitting, isValid }) => {
          if (errors.bookingSetting && touched.bookingSetting && isSubmitting && !isValid) {
            document.getElementsByClassName('fieldgroup')[0].scrollIntoView({ behavior: "smooth" });
          }
          return (
            <Form>
              <div>
                {this.renderCalendarMessage()}
                <div className="fieldgroup">
                  <h5>Booking Settings <i className="fas fa-asterisk required-asterisk"></i></h5>
                  <div className="fieldgroup">
                    <FormikRadioButton name="bookingSetting" value="Instant"
                      label={<span>Instant Book <ToolTip position="right" message={instantToolTip}>
                        <i className="far fa-question-circle"></i></ToolTip></span>} />
                  </div>
                  <div className="fieldgroup">
                    <FormikRadioButton name="bookingSetting" value="Request"
                      label={<span>Request a Stay <ToolTip position="right" message={requestToolTip}>
                        <i className="far fa-question-circle"></i></ToolTip></span>} />
                  </div>
                  <ErrorMessage name="bookingSetting" component="div" className="error-message" />
                </div>
                <h5>Manage Availability & Pricing</h5>
                <p>Select a date range on the calendar to mark as unavailable or available at a specific rate. Then click the <b>
                  Update Calendar</b> button to see your changes.</p>
                <div className="fieldgroup">
                  <div>
                    <label>
                      <input type="radio"
                        name="type"
                        onChange={() => { this.setState({ singleDay: true, selectedDaysParent: [], from: undefined, to: undefined }) }}
                        value="singleDay"
                        checked={this.state.singleDay === true}
                      />
                      Select Single Day
                    </label>
                  </div>
                  <div>
                    <label>
                      <input type="radio"
                        name="type"
                        onChange={() => { this.setState({ singleDay: false, selectedDaysParent: [], from: undefined, to: undefined }) }}
                        value="dateRange"
                        checked={this.state.singleDay === false}
                      />
                      Select Date Range
                    </label>
                  </div>
                </div>
                <div className="radio-button-description">{this.state.singleDay === true ?
                  <p>Select individual or multiple days to change their price or make unavailable</p> :
                  <p>Select <strong>first</strong> and <strong>last</strong> dates to select a range of dates to change their price or make unavailable</p>}
                </div>
                <CalendarComponent
                  modifiers={getAdminModifiers(formData.pricing.overrides, calendars, calendarBookings)}
                  weekendFee={formData.pricing.weekend_fee}
                  baseFee={formData.pricing.baseFee}
                  dateHandler={this.dateHandler}
                  selectedDaysParent={this.state.selectedDaysParent}
                  singleDay={this.state.singleDay}
                  from={this.state.from}
                  to={this.state.to} />
                <div className="fieldgroup row mt-4">
                  <div className="fieldgroup col-12 col-sm-3 m-0 mt-2">
                    <FormikRadioButton
                      name="availability"
                      value="Available"
                      disabled={this.state.selectedDaysParent.length === 0}
                    />
                    <FormikRadioButton
                      name="availability"
                      value="Unavailable"
                      disabled={this.state.selectedDaysParent.length === 0}
                    />
                    <div>
                      <label className="d-inline">Price:</label>
                      <span className="dollar-field price-override">
                        <Field
                          style={{maxWidth: '100px', height: '40px' }}
                          name="adjustment"
                          type="number"
                          className="form-control"
                          disabled={!(this.state.selectedDaysParent.length > 0 && values.availability === "Available")} />
                      </span>
                      <ErrorMessage name="adjustment" component="div" className="error-message col-12" />
                    </div>
                  </div>
                </div>
                <div className="button-row row text-center">
                  <div className="col mb-4">
                    <button disabled={!(this.state.selectedDaysParent.length > 0 && values.availability)} className="btn-secondary"
                      type="button" onClick={() => this.update(values, setSubmitting, errors)}>Update Calendar</button>
                  </div>
                </div>
                <div className="button-row row">
                  <div className="col-4">
                    <label className="float-left" onClick={() => { this.submitAndBack(values) }}>Back</label>
                  </div>
                  <div className="col-8">
                    <div className="row">
                      <div className="col-md-6 col-12">
                        {this.props.workflow !== "edit" &&
                          <label className="float-right" onClick={() => { this.submitAndExit(values) }}>Save & Finish Later</label>
                        }
                      </div>
                      <div className="col-md-6 col-12">
                        {this.state.isSubmitting ?
                          <button className="btn-primary float-right" disabled={true} onClick={() => { }}>Saving...</button> :
                          <button className="btn-primary float-right" type="submit">
                            {submitButtonText}
                          </button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormManageAvailability));
